import React, { useCallback } from 'react';

import SearchResults from '../../../search-filter/components/search-results';
import ProductFilter from '../../../product/components/product-filter';
import ProductResults from '../../../product/components/product-results';
import ProductMap from '../../../product/components/product-map';
import StickyBar from '../../../sale-page/components/sale-page-tabs/sticky-nav';
import { SORT_TYPES } from '../../../product/components/product-list';
import { withProductContainer } from '../../../product/components/product-container';
import { Helpers } from '../../../core/src/helpers';

const getFilterCondition = Helpers.memoize((searchResults, query, prdFilterCondition) => (prd, params) => {
    let { prdClass } = prd;
    //if filters are enabled ,ignore auto hide functionality
    if (searchResults && searchResults.length > 0) {
        //do not show user defined banners when filtering
        if (prdClass === 'USER_DEFINED') {
            return Object.keys(query || {}).length === 0;
        }
        return searchResults.indexOf(prd.sku) > -1;
    }
    return prdFilterCondition(prd, params);
});

const EMPTY_OBJ = {};
export default withProductContainer(
    ({
        leftMenu,
        createCustomProductCard,
        enableAppPDP,
        ToggleFilter,
        sortGtmActions,
        prdFilterCondition,
        disableSearch,
        sortProducts,
        productCat = { products: [], sortValue: 'rank.recommended' },
        tabProps,
        pg,
    }) => {
        const { products } = productCat;
        const changeSort = useCallback(value => {
            const { analyticsLabel } = SORT_TYPES.find(s => s && s.value === value) || EMPTY_OBJ;
            sortProducts(value, pg, analyticsLabel);
        });

        return (
            <SearchResults>
                {({ results, query, searchInProgress }) => (
                    <ProductFilter
                        products={products}
                        condition={getFilterCondition(
                            !disableSearch && !searchInProgress ? results : null,
                            query,
                            prdFilterCondition
                        )}
                    >
                        {(filteredProducts, childProps) => {
                            const productListLength = filteredProducts.filter(
                                p => p.prdClass !== 'USER_DEFINED'
                            ).length;
                            const { priceReady, checkCondition } = childProps || EMPTY_OBJ;
                            const gotFinalProducts = priceReady && !searchInProgress;
                            return (
                                <>
                                    <ProductResults>
                                        <div className="slp-results-bar-container">
                                            <StickyBar
                                                sortOptions={SORT_TYPES}
                                                changeSort={changeSort}
                                                productCat={productCat}
                                                productListLength={productListLength}
                                                gotFinalProducts={gotFinalProducts}
                                                ToggleFilter={ToggleFilter}
                                                sortGtmActions={sortGtmActions}
                                                disableSearch={disableSearch}
                                                tabProps={tabProps ? { ...tabProps, isV2: true } : null}
                                                mobileNested={false}
                                            />
                                        </div>
                                        <div className="products-list">
                                            {leftMenu}
                                            <ProductMap
                                                products={filteredProducts}
                                                productItem={createCustomProductCard}
                                                enableAppPDP={enableAppPDP}
                                                lazyLoadPlaceHolderHeight={1040}
                                                productItemClassName={'gift-guide-product-card'}
                                                customPlaceHolder={true}
                                                disableMultiContainers={true}
                                                containerClassName="column-container"
                                            />
                                        </div>
                                    </ProductResults>
                                </>
                            );
                        }}
                    </ProductFilter>
                )}
            </SearchResults>
        );
    }
);
